import React, { Component, useState } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  Label,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  NavItem,
  NavLink,
  TabContent,
  TabPane

} from "reactstrap";

import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  ErrorModal,
  RavenAgTable,
  MessageModal,
  MerchantAgreementModal,
  FileUploader,
  WarningModal,
  ImageViewer

} from "../../components/Common/CombinedComponents";
import RavenFormikField from "../../components/Common/RavenFormikField";
import PageModalFooter from "../../components/Common/PageComponents/PageModalFooter";
import classnames from "classnames";

import {
  getDateTime,
  getTitleValue,
  getInitValueTriple,
  getInitValue,
  getInvalid,
} from "../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import { getLastTextAfterSeperator } from "../../common/Library/commonFunctions";

import {
  addMerchantApplication,
  merchantApplicationApiError,
  getUserCanMakeApplication,
  getUserCanApproveAgreement,
  getUsersMerchantApplication,
  getApplicationStatusDef,
  getApplicationSubStatusDef,
  getPaymentMethodDef,
  getMccList,
  getCityDefinition,
  getCountryList,
  getCountryStateDefinition,
  getDistrictDefinition,
  getCompanyTypeDef,
  getMerchantAgreements,
  approveMerchantAgreement,
  getDocumentTypes,
  getApplicationDocumentByGuid,
  getMerchantFileView
} from "../../store/actions";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const phoneRegex = /[1-9]{1}[0-9]{9}/;
const patternNumeric = /^\d+$/;
const documentTypes = {
  identityFile: "1",
  signatureFile: "2",
  taxFile: "3",
  addinitionalFile: "4"
};

class MerchantApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      recordList: [],
      cmbMccList: [],
      cmbCountryList: [],
      selectedCountryGuid: 0,
      cmbCityList: [],
      selectedCityGuid: 0,
      cmbDistrictList: [],
      cmbCountryStateList: [],
      cmbCompanyTypeList: [],
      messageModal: false,
      merchantAgreementModal: false,
      agreementSelected: [],
      merchantAgreementList: [],
      merchantDocumentList: [],
      recordDocumentList: [],
      agreement: "",
      merchant: "",
      modal: false,
      agreementPopUpModal: false,
      record: "",
      recordGet: "",
      recordGetApprove: "",
      userName: localStorage.getItem("username"),
      errorModal: false,
      addAnother: false,
      isEdit: false,
      isDetail: false,
      canApproveAgreement: false,
      canMakeApplication: false,
      selectedFile: null,
      message: "",
      agreementsCreated: false,
      applicationRecieved: false,
      warningModal: false,
      warningMessage: "",
      uploadDocumentList: [],
      uploadTaxFile: "",
      uploadSignatureFile: "",
      uploadIdentityFile: "",
      uploadAdditionalFile: "",
      selectedSubMerchantId: "",
      isDocumentViewer: false,
      recordcolumns: [
        {
          headerName: this.props.t("applicationNo"),
          field: "applicationNo"
        },
        {
          headerName: this.props.t("contactName"),
          field: "merchant.contactName"
        },
        {
          headerName: this.props.t("contactSurname"),
          field: "merchant.contactSurname"
        },
        {
          headerName: this.props.t("ownerIdentityNumber"),
          field: "merchant.ownerIdentityNumber"
        },
        {
          headerName: this.props.t("contactDateOfBirth"),
          field: "merchant.contactDateOfBirth",
          filter: "agDateTimeColumnFilter",
          hide: true,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("contactEmail"),
          field: "merchant.contactEmail"
        },
        {
          headerName: this.props.t("contactPhoneNumber"),
          field: "merchant.contactPhoneNumber"
        },
        {
          headerName: this.props.t("applicationDate"),
          field: "applicationDate"
        },
        {
          headerName: this.props.t("commercialName"),
          field: "merchant.commercialName"
        },
        {
          headerName: this.props.t("taxOffice"),
          field: "merchant.taxOffice"
        },
        {
          headerName: this.props.t("taxNumber"),
          field: "merchant.taxNumber"
        },
        {
          headerName: this.props.t("webUrl"),
          field: "merchant.webUrl"
        },
        {
          headerName: this.props.t("countryName"), field: "merchant.countryGuid",
          valueFormatter: params => {
            let constObj = this.props.cmbCountryList.filter(
              x => x.guid == params.value
            );
            let a = constObj.map(x => x.countryName)
            return a
          },
        },
        {
          headerName: this.props.t("cityName"), field: "merchant.cityName",
        },
        {
          headerName: this.props.t("districtName"), field: "merchant.districtGuid", hide: true,
          valueFormatter: params => {
            let constObj = this.props.cmbDistrictList.filter(
              x => x.guid == params.value
            );
            return constObj.map(x => x.districtName)
          },
        },
        {
          headerName: this.props.t("neighborhood"),
          field: "merchant.neighborhood"
        },
        {
          headerName: this.props.t("postalCode"),
          field: "merchant.postalCode"
        },
        {
          headerName: this.props.t("addressline1"),
          field: "merchant.addressline1"
        },
        {
          headerName: this.props.t("addressline2"),
          field: "merchant.addressline2"
        },
        {
          headerName: this.props.t("addressline3"),
          field: "merchant.addressline3"
        },
        {
          headerName: this.props.t("mccGuid"), field: "merchant.mccGuid",
          valueFormatter: params => {
            let constObj = this.props.cmbMccList.filter(
              x => x.guid == params.value
            );
            let a = constObj.map(x => x.mcc)
            let b = constObj.map(x => x.description)
            return a + "  -  " + b
          },
        },
        {
          headerName: this.props.t("paymentMethodGuid"), field: "merchant.paymentMethodGuid",
          valueFormatter: params => {
            let constObj = this.props.cmbPaymentMethodList.filter(
              x => x.guid == params.value
            );
            return constObj.map(x => x.name)
          },
        },
        {
          headerName: this.props.t("applicationStatusGuid"), field: "applicationStatusGuid",
          valueFormatter: params => {
            let constObj = this.props.cmbApplicationStatusList.filter(
              x => x.guid == params.value
            );
            return constObj.map(x => x.name)
          },
        },
        {
          headerName: this.props.t("applicationSubStatusGuid"), field: "applicationSubStatusGuid",
          valueFormatter: params => {
            let constObj = this.props.cmbApplicationSubStatusList.filter(
              x => x.guid == params.value
            );
            return constObj.map(x => x.name)
          },
        },
        {
          headerName: this.props.t("updateDateTime"),
          field: "updateDatetime",
          filter: "agDateTimeColumnFilter",
          hide: true,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
      ],
      documentRecordcolumns: [
        {
          headerName: this.props.t("documentType"),
          field: "documentTypeDef.name"
        },
        {
          headerName: this.props.t("documentId"),
          field: "documentId"
        },
        {
          headerName: this.props.t("ipAddress"),
          field: "ip"
        },
        {
          headerName: this.props.t("browser"),
          field: "browser"
        },
        {
          headerName: this.props.t("updateDateTime"),
          field: "updateDatetime",
          filter: "agDateTimeColumnFilter",
          hide: true,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
      ]
    };

    this.toggle = this.toggle.bind(this);
    this.handleValidRecordSubmit = this.handleValidRecordSubmit.bind(this);
    this.handleAddRecordClick = this.handleAddRecordClick.bind(this);
    this.handleDetailClick = this.handleDetailClick.bind(this);
    this.handleDocumentDetailClick = this.handleDocumentDetailClick.bind(this);
    this.handleMerchantAgreements = this.handleMerchantAgreements.bind(this);
    this.handleCheckBox = this.handleCheckBox.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.toggleAgreementPopUpModal = this.toggleAgreementPopUpModal.bind(this);
    this.handleValidMerchantAgreementSubmit = this.handleValidMerchantAgreementSubmit.bind(this);
  }

  componentDidMount() {
    this.props.apiError("");
    const {
      recordList,
      onGetRecordList,
      onGetMccDefinition,
      cmbMccList,
      cmbCountryList, onGetCountryDefinition,
      cmbCityList, onGetCityDefinition,
      cmbCountryStateList, onGetCountryStateDefinition,
      cmbDistrictList, onGetDistrictDefinition,
      cmbCompanyTypeList, onGetCompanyTypeDefinition,
      cmbPaymentMethodList, onGetPaymentMethodDefinition,
      cmbApplicationSubStatusList, onGetApplicationSubStatusDefinition,
      cmbApplicationStatusList, onGetApplicationStatusDefinition,
      merchantAgreementList, onGetMerchantAgreementList,
      onGetUserCanMakeApplication, canMakeApplication,
      onGetUserCanApproveAgreement, canApproveAgreement,
      merchantDocumentList, onGetMerchantDocumentList,
    } = this.props;

    this.state.uploadDocumentList.splice(0);

    onGetCountryDefinition();
    this.setState({ cmbCountryList });

    onGetCityDefinition();
    this.setState({ cmbCityList });

    onGetCountryStateDefinition();
    this.setState({ cmbCountryStateList });

    onGetDistrictDefinition();
    this.setState({ cmbDistrictList });

    onGetMccDefinition();
    this.setState({ cmbMccList });

    onGetCompanyTypeDefinition();
    this.setState({ cmbCompanyTypeList });

    onGetPaymentMethodDefinition();
    this.setState({ cmbPaymentMethodList });

    onGetApplicationSubStatusDefinition();
    this.setState({ cmbApplicationSubStatusList });

    onGetApplicationStatusDefinition();
    this.setState({ cmbApplicationStatusList });

    onGetMerchantAgreementList();
    this.setState({ merchantAgreementList });

    onGetMerchantDocumentList();
    this.setState({ merchantDocumentList });

    onGetUserCanMakeApplication({ userName: localStorage.getItem("username") });
    this.setState({ canMakeApplication });

    onGetUserCanApproveAgreement({ userName: localStorage.getItem("username") });
    this.setState({ canApproveAgreement });

    onGetRecordList({ userName: localStorage.getItem("username") });
    this.setState({ recordList });

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { error, merchantAgreementList, recordList, recordDocumentList, applicationRecieved, agreementsCreated, waitingFileBase64String, fileViewData } = this.props;

    if (prevProps.error !== error) {
      this.setState({ error: error });
      this.state.uploadDocumentList.splice(0);
    }
    if (prevProps.merchantAgreementList !== merchantAgreementList) {
      this.setState({ merchantAgreementList: merchantAgreementList });
    }
    if (prevProps.recordList !== recordList) {
      this.setState({ recordList: recordList });
    }
    if (prevProps.recordDocumentList !== recordDocumentList) {
      this.setState({ recordDocumentList: recordDocumentList });
    }

    if (prevProps.fileViewData !== fileViewData) {
      this.setState({ fileViewData: fileViewData });
      this.setState({ isDocumentViewer: true });
    }

    if (prevProps.waitingFileBase64String !== waitingFileBase64String) {
      this.setState({ waitingFileBase64String: waitingFileBase64String });
    }

    if (applicationRecieved && prevProps.applicationRecieved !== applicationRecieved)
      this.setState({ messageModal: true, message: this.props.t("yourApplicationHasBeenSuccessfullyReceived") });

    if (agreementsCreated && prevProps.agreementsCreated !== agreementsCreated) {
      this.setState({ messageModal: true, message: this.props.t("yourAgreementsHasBeenSuccessfullyCreated") });
    }

  }

  handleMerchantAgreements = (values) => {
    this.toggleAgreementPopUpModal();
  };

  handleDetailClick = values => {

    const { onGetApplicationDocument } = this.props;
    const { recordDocumentList } = this.state;

    onGetApplicationDocument({ applicationGuid: values.guid });
    this.setState({ recordDocumentList });

    this.setState({
      record: values,
      isDetail: true,
      addAnother: false,
      isEdit: true,
      activeTab: "1",
      selectedCountryGuid: values.merchant?.countryGuid,
      selectedCityGuid: values.merchant?.cityGuid,
      selectedPaymentMethodGuid: values.paymentMethodGuid,
      selectedSubMerchantId: values.merchant?.subMerchantId,
    });

    this.toggle();
  };

  handleDocumentDetailClick = values => {

    const { onGetDocumentFileView } = this.props;
    const { selectedSubMerchantId } = this.state;
    let request = { subMerchantId: selectedSubMerchantId, documentId: values.documentId };
    onGetDocumentFileView(request);
  };


  handleAddRecordClick = () => {
    this.setState({ activeTab: "1" });
    this.setState({ record: "", isEdit: false });
    this.setState({ selectedCountryGuid: 0, });
    this.setState({ selectedCityGuid: 0, });
    this.setState({ selectedPaymentMethodGuid: 1, });

    this.toggle();
  };

  handleValidRecordSubmit = values => {
    const { onAddRecord } = this.props;
    const { uploadDocumentList, uploadTaxFile, uploadSignatureFile, uploadIdentityFile, uploadAdditionalFile } = this.state;

    if (values.countryGuid < 1)
      values.countryGuid = null;
    if (values.cityGuid < 1)
      values.cityGuid = null;

    if (values.districtGuid < 1)
      values.districtGuid = null;
    if (values.companyTypeGuid < 1)
      values.companyTypeGuid = null;
    if (values.paymentMethodGuid < 1)
      values.paymentMethodGuid = null;

    if (uploadTaxFile != null && uploadTaxFile.documentType != undefined) {
      uploadDocumentList.push(uploadTaxFile);
    }
    if (uploadSignatureFile != null && uploadSignatureFile.documentType != undefined) {
      uploadDocumentList.push(uploadSignatureFile);
    }
    if (uploadIdentityFile != null && uploadIdentityFile.documentType != undefined) {
      uploadDocumentList.push(uploadIdentityFile);
    }
    if (uploadAdditionalFile != null && uploadAdditionalFile.documentType != undefined) {
      uploadDocumentList.push(uploadAdditionalFile);
    }

    const formData = new FormData();
    formData.append("OwnerIdentityNumber", values.ownerIdentityNumber);
    formData.append("ContactName", values.contactName);
    formData.append("ContactSurname", values.contactSurname);
    formData.append("ContactEmail", values.contactEmail);
    formData.append("ContactPhoneNumber", values.contactPhoneNumber);
    formData.append("ContactDateOfBirth", values.contactDateOfBirth);
    formData.append("CompanyName", values.companyName);
    formData.append("CommercialName", values.commercialName);
    formData.append("TaxOffice", values.taxOffice);
    formData.append("TaxNumber", values.taxNumber);
    formData.append("WebUrl", values.webUrl);
    formData.append("MccGuid", values.mccGuid);
    formData.append("Neighborhood", values.neighborhood);
    formData.append("CityGuid", values.cityGuid);
    formData.append("CityName", values.cityName);
    formData.append("DistrictGuid", values.districtGuid);
    formData.append("DistrictName", values.districtName);
    formData.append("CountryGuid", values.countryGuid);
    formData.append("CompanyTypeGuid", values.companyTypeGuid);
    formData.append("PostalCode", values.postalCode);
    formData.append("Addressline1", values.addressline1);
    formData.append("Addressline2", values.addressline2);
    formData.append("Addressline3", values.addressline3);
    formData.append("TradeRegisterNumber", values.tradeRegisterNumber);
    formData.append("PaymentMethodGuid", values.paymentMethodGuid);
    formData.append("UserData", values.userData);

    uploadDocumentList.forEach((fileData, index) => {
      formData.append(`UploadDocumentList[${index}].File`, fileData.file);
      formData.append(`UploadDocumentList[${index}].DocumentType`, fileData.documentType);
    });

    onAddRecord(formData);

    !this.state.addAnother && this.toggle();
  };

  handleValidMerchantAgreementSubmit = () => {
    const { onApproveMerchantAgreement, merchantAgreementList, onGetRecordList } = this.props;
    const { recordList } = this.state;
    if (this.state.agreementSelected.length === 0) {
      let error = {
        message: this.props.t("merchantAgreementChooseError"),
        code: "merchantAgreementChooseError",
      };
      this.setState({ errorModal: true, error: error });
      return;
    }
    if (merchantAgreementList !== undefined) {
      let filteredRecord = "";
      let isForced = false;
      let isAgreementForcedError = false;
      merchantAgreementList.forEach(item => {
        isForced = item.isForced;
        filteredRecord = this.state.agreementSelected.filter(
          x => x.guid == item.guid,
        );
        if (filteredRecord.length === 0 && isForced) {
          isAgreementForcedError = true;
        }
      });

      if (isAgreementForcedError) {
        let error = {
          message: this.props.t("merchantAgreementIsForcedError"),
          code: "merchantAgreementIsForcedError",
        };
        this.setState({ errorModal: true, error: error });
        return;
      }
    }
    const data = {
      userName: localStorage.getItem("username"),
      isAgreementApproved: true,
      merchantAgreements: this.state.agreementSelected,
    };

    onApproveMerchantAgreement(data);

    onGetRecordList({ userName: localStorage.getItem("username") })
    this.setState({ recordList });
    this.toggleAgreementPopUpModal();
  };

  handleCountrySelectChange = (options, setFieldValue) => {
    setFieldValue("cityName", "");
    setFieldValue("districtName", "");
    setFieldValue("stateName", "");
    setFieldValue("cityGuid", "");
    setFieldValue("districtGuid", "");

    this.setState({ selectedCountryGuid: options.value });
    this.setState({ selectedCityGuid: 0 });
  }

  handleCitySelectChange = (options, setFieldValue) => {
    setFieldValue("cityName", options.value < 1 ? "" : getLastTextAfterSeperator(options.label, " - "))
    setFieldValue("districtGuid", "");
    setFieldValue("districtName", "");
    this.setState({ selectedCityGuid: options.value });

  }

  handleDistrictSelectChange = (options, setFieldValue) => {
    setFieldValue("districtName", options.value < 1 ? "" : getLastTextAfterSeperator(options.label, " - "))
  }

  handleCheckBox(e, item) {
    const selectedGuid = item.guid;
    if (e.target.checked) {
      this.state.agreementSelected.push({ guid: selectedGuid });
    } else if (!e.target.checked) {
      let arraySplice = this.state.agreementSelected.map(x => x.guid);
      let index = arraySplice.indexOf(item.guid);
      if (index !== -1) {
        arraySplice.splice(index, 1);
        const mappedArraySplice = arraySplice.map(x => ({ guid: x }));
        this.setState({ agreementSelected: mappedArraySplice });
      }
    }
  }

  onCloseMessageModalClickClick = e => {
    e.preventDefault();
    this.setState({ messageModal: false });
  };

  clickHandler(e, item) {
    let el = e.target;
    while (el && el !== e.currentTarget && el.tagName !== "B") {
      el = el.parentNode;
    }
    if (el && el.tagName === "B") {
      this.setState({ agreement: item });
      this.setState({ merchantAgreementModal: true });
    }
  }

  removeDocumentByType(documentType) {
    let removeItemIndex = this.state.uploadDocumentList.indexOf(this.state.uploadDocumentList.filter(item => item.documentType !== documentType)[0]);
    this.state.uploadDocumentList.splice(removeItemIndex, 1);
  }

  onFileChangeTax = (file) => {
    this.setState({ uploadTaxFile: { file: file, documentType: documentTypes.taxFile } })
  };

  onFileClickTax = () => {
    const { uploadDocumentList } = this.state;
    let documentType = 0;
    let array = uploadDocumentList
      .filter(i => i.documentType === documentTypes.taxFile)
      .map(x => x);
    if (array?.length) documentType = array[0].documentType;

    if (documentType > 0) {
      this.removeDocumentByType(documentType);
      this.setState({ uploadTaxFile: "" });

    }
  };

  onFileChangeSignatureCircularFile = (file) => {
    this.setState({ uploadSignatureFile: { file: file, documentType: documentTypes.signatureFile } })
  };

  onFileClickSignature = () => {
    const { uploadDocumentList } = this.state;
    let documentType = 0;
    let array = uploadDocumentList
      .filter(i => i.documentType === documentTypes.signatureFile)
      .map(x => x);
    if (array?.length) documentType = array[0].documentType;

    if (documentType > 0) {
      this.removeDocumentByType(documentType);
      this.setState({ uploadSignatureFile: "" });

    }
  };

  onFileChangeIdentityFile = (file) => {
    this.setState({ uploadIdentityFile: { file: file, documentType: documentTypes.identityFile } })
  };

  onFileClickIdentity = () => {
    const { uploadDocumentList } = this.state;
    let documentType = 0;
    let array = uploadDocumentList
      .filter(i => i.documentType === documentTypes.identityFile)
      .map(x => x);
    if (array?.length) documentType = array[0].documentType;

    if (documentType > 0) {
      this.removeDocumentByType(documentType);
      this.setState({ uploadIdentityFile: "" });

    }
  };

  onFileChangeAdditionalDocuments = (file) => {
    this.setState({ uploadAdditionalFile: { file: file, documentType: documentTypes.addinitionalFile } })
  };

  onFileClickAdditional = () => {
    const { uploadDocumentList } = this.state;
    let documentType = 0;
    let array = uploadDocumentList
      .filter(i => i.documentType === documentTypes.addinitionalFile)
      .map(x => x);
    if (array?.length) documentType = array[0].documentType;

    if (documentType > 0) {
      this.removeDocumentByType(documentType);
      this.setState({ uploadAdditionalFile: "" });

    }
  };

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (this.state.modal) {
      setTimeout(() => this.setState({ isDetail: false }), 150);
    }
  }

  toggleAgreementPopUpModal() {
    this.setState(prevState => ({ agreementPopUpModal: !prevState.agreementPopUpModal, }));
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const { recordList, merchantAgreementList, canMakeApplication, canApproveAgreement } = this.props;
    const { record, error } = this.state;

    function NullControl(item) {
      return item != null;
    }
    const getDescription = item => {
      if (item.linkedText) {
        const re = new RegExp(item.linkedText, "g");
        return item.description.replace(re, `<b>${item.linkedText}</b>`);
      } else {
        return item.description;
      }
    };
    const { selectedCityGuid, messageModal, merchantAgreementModal, agreement, warningMessage, warningModal, isDocumentViewer } = this.state;
    return (
      <React.Fragment>
        <MessageModal
          messageText={this.state.message}
          messageDetailText={this.state.message}
          show={messageModal}
          onCloseClick={this.onCloseMessageModalClickClick}
        />
        {error && (<ErrorModal errorMessage={error} onCloseModalClick={() => this.setState({ error: undefined, messageModal: false })} />)}
        <ToastContainer />
        <WarningModal
          warningMessage={warningMessage}
          show={warningModal}
          onCloseClick={() => this.setState({ warningModal: false })}
        />
        <MerchantAgreementModal
          title={agreement.name}
          message={agreement.agreementContent}
          show={merchantAgreementModal}
          onCloseClick={() => this.setState({ merchantAgreementModal: false })}
        />

        {
          isDocumentViewer && (<ImageViewer base64String={this.props.fileViewData.base64String} documentType={this.props.fileViewData.documentType} imageViewerModal={this.state.isDocumentViewer} onCloseClick={() => this.setState({ isDocumentViewer: false })} title={this.props.t("documentViewer")} closeButtonName={this.props.t("cancel")} />)
        }

        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <RavenAgTable
                      mainButton={this.props.t("newMerchantApplication")}
                      secondButton={this.props.t("approveMerchantAgreements")}
                      onAddClick={canMakeApplication ? this.handleAddRecordClick : null}
                      onDetailClick={this.handleDetailClick}
                      actionItems={true}
                      exportOption={false}
                      recordcolumns={this.state.recordcolumns}
                      recordList={recordList}
                      breadCrumbTitle={this.props.t("merchantManagement")}
                      breadCrumbItem={this.props.t("merchantApplication")}
                      onSecondButtonClick={canApproveAgreement ? this.handleMerchantAgreements : null}
                    />
                    <Modal
                      isOpen={this.state.modal}
                      className={this.props.className}
                      onClose={this.toggleModalClose}
                      size="xl"
                      backdrop={"static"}
                      id="staticBackdrop"
                    >
                      <ModalHeader toggle={this.toggle} tag="h4">
                        {getTitleValue(this, "merchantApplication")}
                      </ModalHeader>
                      <ModalBody>
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            applicationNo: getInitValue(record, record.applicationNo),
                            applicationStatusGuid: getInitValue(record, record.applicationStatusGuid),
                            applicationSubStatusGuid: getInitValue(record, record.applicationSubStatusGuid),
                            contactName: getInitValueTriple(record, record.merchant, record.merchant?.contactName),
                            contactSurname: getInitValueTriple(record, record.merchant, record.merchant?.contactSurname),
                            contactDateOfBirth: getInitValueTriple(record, record.merchant, record.merchant?.contactDateOfBirth).slice(0, 10),
                            contactPhoneNumber: getInitValueTriple(record, record.merchant, record.merchant?.contactPhoneNumber),
                            ownerIdentityNumber: getInitValueTriple(record, record.merchant, record.merchant?.ownerIdentityNumber),
                            contactEmail: getInitValueTriple(record, record.merchant, record.merchant?.contactEmail),
                            mccGuid: getInitValueTriple(record, record.merchant, record.merchant?.mccGuid),
                            companyName: getInitValueTriple(record, record.merchant, record.merchant?.companyName),
                            commercialName: getInitValueTriple(record, record.merchant, record.merchant?.commercialName),
                            taxNumber: getInitValueTriple(record, record.merchant, record.merchant?.taxNumber),
                            taxOffice: getInitValueTriple(record, record.merchant, record.merchant?.taxOffice),
                            tradeRegisterNumber: getInitValueTriple(record, record.merchant, record.merchant?.tradeRegisterNumber),
                            addressline1: getInitValueTriple(record, record.merchant, record.merchant?.addressline1),
                            addressline2: getInitValueTriple(record, record.merchant, record.merchant?.addressline2),
                            addressline3: getInitValueTriple(record, record.merchant, record.merchant?.addressline3),
                            countryGuid: getInitValueTriple(record, record.merchant, record.merchant?.countryGuid),
                            cityGuid: getInitValueTriple(record, record.merchant, record.merchant?.cityGuid),
                            districtGuid: getInitValueTriple(record, record.merchant, record.merchant?.districtGuid),
                            postalCode: getInitValueTriple(record, record.merchant, record.merchant?.postalCode),
                            webUrl: getInitValueTriple(record, record.merchant, record.merchant?.webUrl),
                            neighborhood: getInitValueTriple(record, record.merchant, record.merchant?.neighborhood),
                            subMerchantId: getInitValueTriple(record, record.merchant, record.merchant?.subMerchantId),
                            userData: localStorage.getItem("username"),
                            companyTypeGuid: getInitValueTriple(record, record.merchant, record.merchant?.companyTypeGuid),
                            paymentMethodGuid: getInitValueTriple(record, record.merchant, record.merchant?.paymentMethodGuid),
                          }}
                          validationSchema={Yup.object().shape({
                            contactName: Yup.string()
                              .strict(true)
                              .max(
                                50,
                                this.props.t("maxLengthError").format("50"),
                              )
                              .required(this.props.t("mustBe")),
                            contactSurname: Yup.string()
                              .strict(true)
                              .max(
                                50,
                                this.props.t("maxLengthError").format("50"),
                              )
                              .required(this.props.t("mustBe")),
                            contactEmail: Yup.string()
                              .strict(true)
                              .max(
                                150,
                                this.props.t("maxLengthError").format("150"),
                              )
                              .required(this.props.t("mustBe"))
                              .matches(
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/,
                                this.props.t("invalidEmail")
                              ),
                            contactPhoneNumber: Yup.string()
                              .strict(true)
                              .required(this.props.t("mustBe"))
                              .max(
                                10,
                                this.props.t("maxLengthError").format("10"),
                              )
                              .matches(
                                phoneRegex,
                                this.props.t("nosymbol"),
                              ),
                            mccGuid: Yup.string()
                              .strict(true)
                              .required(this.props.t("mustBe")),
                            contactDateOfBirth: Yup.string()
                              .strict(true)
                              .required(this.props.t("mustBe")),
                            companyName: Yup.string()
                              .strict(true)
                              .max(
                                140,
                                this.props.t("maxLengthError").format("140"),
                              )
                              .min(
                                3,
                                this.props.t("minLengthError").format("3"),
                              )
                              .required(this.props.t("mustBe")),
                            commercialName: Yup.string()
                              .strict(true)
                              .max(
                                140,
                                this.props.t("maxLengthError").format("140"),
                              )
                              .min(
                                3,
                                this.props.t("minLengthError").format("3"),
                              )
                              .required(this.props.t("mustBe")),
                            taxNumber: Yup.string()
                              .strict(true)
                              .max(
                                11,
                                this.props.t("maxLengthError").format("11"),
                              )
                              .min(
                                10,
                                this.props.t("minLengthError").format("10"),
                              )
                              .required(this.props.t("mustBe"))
                              .matches(
                                patternNumeric,
                                this.props.t("invFormat"),
                              ),
                            taxOffice: Yup.string()
                              .strict(true)
                              .max(
                                140,
                                this.props.t("maxLengthError").format("140"),
                              ),
                            tradeRegisterNumber: Yup.string()
                              .strict(true)
                              .max(
                                16,
                                this.props.t("maxLengthError").format("16"),
                              )
                              .matches(
                                patternNumeric,
                                this.props.t("invFormat"),
                              ),
                            addressline1: Yup.string()
                              .strict(true)
                              .max(
                                100,
                                this.props.t("maxLengthError").format("100"),
                              )
                              .required(this.props.t("mustBe")),
                            addressline2: Yup.string()
                              .strict(true)
                              .max(
                                100,
                                this.props.t("maxLengthError").format("100"),
                              ),
                            addressline3: Yup.string()
                              .strict(true)
                              .max(
                                100,
                                this.props.t("maxLengthError").format("100"),
                              ),
                            districtGuid: Yup.string()
                              .strict(true)
                              .required(this.props.t("mustBe")),
                            cityGuid: Yup.string()
                              .strict(true)
                              .required(this.props.t("mustBe")),
                            countryGuid: Yup.string()
                              .strict(true)
                              .required(this.props.t("mustBe")),
                            postalCode: Yup.string()
                              .strict(true)
                              .max(
                                10,
                                this.props.t("maxLengthError").format("10"),
                              )
                              .required(this.props.t("mustBe")),
                            webUrl: Yup.string()
                              .strict(true)
                              .max(
                                100,
                                this.props.t("maxLengthError").format("100"),
                              )
                              .required(this.props.t("mustBe"))
                              .matches(
                                /^www\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/i,
                                this.props.t("invalidUrl"),
                              ),
                            neighborhood: Yup.string()
                              .strict(true)
                              .max(
                                20,
                                this.props.t("maxLengthError").format("20"),
                              ),
                            ownerIdentityNumber: Yup.string()
                              .strict(true)
                              .max(
                                11,
                                this.props.t("maxLengthError").format("11"),
                              )
                              .min(
                                11,
                                this.props.t("minLengthError").format("11"),
                              )
                              .matches(
                                patternNumeric,
                                this.props.t("invFormat"),
                              ),
                            companyTypeGuid: Yup.number()
                              .strict(true)
                              .required(this.props.t("mustBe")),
                            paymentMethodGuid: Yup.number()
                              .strict(true)
                              .required(this.props.t("mustBe")),
                          })
                          }
                          onSubmit={values => {
                            this.handleValidRecordSubmit(values);
                          }}
                        >
                          {({ errors, touched, setFieldValue }) => (
                            <Form>
                              <fieldset>
                                <Row>
                                  <Col xl={12}>
                                    <Card>
                                      <ul
                                        className="nav nav-tabs nav-tabs-custom justify-content-left pt-2"
                                        role="tablist"
                                      >
                                        <NavItem>
                                          <NavLink
                                            to="#"
                                            className={classnames({
                                              active:
                                                this.state.activeTab === "1",
                                            })}
                                            onClick={() => {
                                              this.toggleTab("1");
                                            }}
                                          >
                                            {this.props.t(
                                              "contactInfo",
                                            )}
                                          </NavLink>
                                        </NavItem>
                                        <NavItem>
                                          <NavLink
                                            to="#"
                                            className={classnames({
                                              active:
                                                this.state.activeTab === "2",
                                            })}
                                            onClick={() => {
                                              this.toggleTab("2");
                                            }}
                                          >
                                            {this.props.t("merchantInfo")}
                                          </NavLink>
                                        </NavItem>
                                        <NavItem>
                                          <NavLink
                                            to="#"
                                            className={classnames({
                                              active:
                                                this.state.activeTab === "3",
                                            })}
                                            onClick={() => {
                                              this.toggleTab("3");
                                            }}
                                          >
                                            {this.props.t("merchantDocuments")}
                                          </NavLink>
                                        </NavItem>
                                        <NavItem>
                                          <NavLink
                                            to="#"
                                            className={classnames({
                                              active:
                                                this.state.activeTab === "4",
                                            })}
                                            onClick={() => {
                                              this.toggleTab("4");
                                            }}
                                          >
                                            {this.props.t("paymentMethodInfo")}
                                          </NavLink>
                                        </NavItem>
                                      </ul>
                                      <TabContent
                                        className="p-4"
                                        style={{
                                          paddingBottom: "0px !important",
                                        }}
                                        activeTab={this.state.activeTab}
                                      >
                                        <TabPane tabId="1" id="all-post" disabled={this.state.isDetail}>
                                          <Row disabled={this.state.isDetail}>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"contactName"}
                                                label={"contactName"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"contactEmail"}
                                                label={"contactEmail"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"ownerIdentityNumber"}
                                                label={"ownerIdentityNumber"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"contactSurname"}
                                                label={"contactSurname"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"contactPhoneNumber"}
                                                label={"contactPhoneNumber"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  {this.props.t("contactDateOfBirth")}
                                                </Label>
                                                <Field
                                                  style={{ width: "97%" }}
                                                  name="contactDateOfBirth"
                                                  type="date"
                                                  className={
                                                    "form-control" +
                                                    getInvalid(errors.contactDateOfBirth,
                                                      touched.contactDateOfBirth)
                                                  }
                                                  disabled={this.state.isDetail}
                                                />
                                                <ErrorMessage
                                                  name="contactDateOfBirth"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </TabPane>
                                        <TabPane
                                          tabId="2"
                                          id="all-post"
                                          disabled={this.state.isDetail}
                                        >
                                          <Row>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"companyTypeGuid"}
                                                label={"companyTypeGuid"}
                                                component="multiselect"
                                                type="singleselect"
                                                valueList={this.props.cmbCompanyTypeList}
                                                nameOnValueList={"name"}
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"taxOffice"}
                                                label={"taxOffice"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"taxNumber"}
                                                label={"taxNumber"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"companyName"}
                                                label={"companyName"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"commercialName"}
                                                label={"commercialName"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"tradeRegisterNumber"}
                                                label={"tradeRegisterNumber"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"mccGuid"}
                                                label={"mccGuid"}
                                                component="multiselect"
                                                type="singleselect"
                                                valueList={(this.props.cmbMccList || []).filter(x => Number(x.status) === 1)}
                                                nameOnValueList={["mcc", "description"]}
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"countryGuid"}
                                                label={"countryGuid"}
                                                component="multiselect"
                                                type="singleselect"
                                                valueList={this.props.cmbCountryList}
                                                nameOnValueList={["alpha2Code", "countryName"]}
                                                onChange={this.handleCountrySelectChange}
                                                setFieldValue={setFieldValue}
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"cityGuid"}
                                                label={"cityGuid"}
                                                component="multiselect"
                                                type="singleselect"
                                                valueList={this.props.cmbCityList.filter(i => i.countryGuid === this.state.selectedCountryGuid)}
                                                nameOnValueList={["cityCode", "cityName"]}
                                                onChange={this.handleCitySelectChange}
                                                setFieldValue={setFieldValue}
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"districtGuid"}
                                                label={"district"}
                                                component="multiselect"
                                                type="singleselect"
                                                valueList={this.props.cmbDistrictList.filter(i => i.cityGuid === selectedCityGuid)}
                                                nameOnValueList={["districtCode", "districtName"]}
                                                onChange={this.handleDistrictSelectChange}
                                                setFieldValue={setFieldValue}
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"postalCode"}
                                                label={"postalCode"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"neighborhood"}
                                                label={"neighborhood"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"addressline1"}
                                                label={"addressline1"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"addressline2"}
                                                label={"addressline2"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"addressline3"}
                                                label={"addressline3"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                          </Row>
                                        </TabPane>
                                        <TabPane
                                          tabId="3"
                                          id="all-post"
                                        >
                                          {this.state.isDetail
                                            ?
                                            (
                                              <RavenAgTable
                                                onDetailClick={this.handleDocumentDetailClick}
                                                actionItems={true}
                                                exportOption={false}
                                                recordcolumns={this.state.documentRecordcolumns}
                                                recordList={this.state.recordDocumentList}
                                                disabled={false}
                                              />
                                            )
                                            :
                                            (<Row>
                                              <Col xl={3} lg={3}>
                                                <h4 className="text-primary">
                                                  {this.props.t("taxFile")}
                                                </h4>
                                                <FileUploader initialFileName={this.props.t("noSelectedFile")} initialImage={null} onChange={this.onFileChangeTax} onClick={this.onFileClickTax} noSelectedFile={this.props.t("noSelectedFile")} browseFilesToUpload={this.props.t("browseFilesToUpload")} />
                                              </Col>

                                              <Col xl={3} lg={3}>
                                                <h4 className="text-primary">
                                                  {this.props.t("signatureCircularFile")}
                                                </h4>
                                                <FileUploader initialFileName={this.props.t("noSelectedFile")} initialImage={null} onChange={this.onFileChangeSignatureCircularFile} onClick={this.onFileClickSignature} noSelectedFile={this.props.t("noSelectedFile")} browseFilesToUpload={this.props.t("browseFilesToUpload")} />
                                              </Col>
                                              <Col xl={3} lg={3}>
                                                <h4 className="text-primary">
                                                  {this.props.t("identityFile")}
                                                </h4>
                                                <FileUploader initialFileName={this.props.t("noSelectedFile")} initialImage={null} onChange={this.onFileChangeIdentityFile} onClick={this.onFileClickIdentity} noSelectedFile={this.props.t("noSelectedFile")} browseFilesToUpload={this.props.t("browseFilesToUpload")} />
                                              </Col>
                                              <Col xl={3} lg={3}>
                                                <h4 className="text-primary">
                                                  {this.props.t("additionalDocuments")}
                                                </h4>
                                                <FileUploader initialFileName={this.props.t("noSelectedFile")} initialImage={null} onChange={this.onFileChangeAdditionalDocuments} onClick={this.onFileClickAdditional} noSelectedFile={this.props.t("noSelectedFile")} browseFilesToUpload={this.props.t("browseFilesToUpload")} />
                                              </Col>

                                            </Row>
                                            )
                                          }


                                        </TabPane>
                                        <TabPane
                                          tabId="4"
                                          id="all-post"
                                          disabled={this.state.isDetail}
                                        >
                                          <Row>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"paymentMethodGuid"}
                                                label={"paymentMethodGuid"}
                                                component="multiselect"
                                                type="singleselect"
                                                valueList={this.props.cmbPaymentMethodList}
                                                nameOnValueList={"name"}
                                                setFieldValue={setFieldValue}
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col lg={4} className="col-4">
                                              <RavenFormikField
                                                errors={errors}
                                                touched={touched}
                                                name={"webUrl"}
                                                label={"webUrl"}
                                                type="text"
                                                disabled={this.state.isDetail}
                                              />
                                            </Col>
                                          </Row>
                                        </TabPane>
                                      </TabContent>
                                    </Card>
                                  </Col>
                                </Row>
                              </fieldset>
                              <ModalHeader
                                style={{
                                  marginTop: "-30px",
                                  marginBottom: "10px",
                                }}
                              ></ModalHeader>
                              <PageModalFooter
                                isEdit={this.state.isEdit}
                                isDetail={this.state.isDetail}
                                hideAddAnother={true}
                                onCancelClick={() => this.toggle()}
                                onCheckboxClick={() => {
                                  this.setState(prevState => ({
                                    addAnother: !prevState.addAnother,
                                  }));
                                }}
                              />
                            </Form>
                          )}
                        </Formik>
                      </ModalBody>
                    </Modal>
                    <Modal
                      isOpen={this.state.agreementPopUpModal}
                      className={this.props.className}
                      size="xl"
                      backdrop={"static"}
                      id="staticBackdrop"
                    >
                      <ModalHeader toggle={this.toggleAgreementPopUpModal} tag="h4">
                      </ModalHeader>
                      <ModalBody>
                        <Container>
                          <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={10}>
                              <Card className="overflow-hidden">
                                <div className="bg-primary bg-soft" style={{ height: 60 }}>
                                  <Row>
                                    <Col className="col-7">
                                      <div className="text-primary p-4">
                                        <h4 className="text-primary">
                                          {this.props.t("merchantAgreements")}
                                        </h4>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                                <CardBody className="pt-0">
                                  <br></br>
                                  <div className="p-2">
                                    <Formik
                                      initialValues={{
                                        firstName: "",
                                      }}
                                      enableReinitialize={true}
                                      onSubmit={(values, actions) => {
                                        this.handleValidMerchantAgreementSubmit(values, actions);
                                      }}
                                    >
                                      {({ errors, touched, setFieldValue }) => (
                                        <Form>
                                          <Row>
                                            <Col lg={6} className="col-6">
                                              <Col lg={12} className="col-12">
                                                <div className="mt-3 d-grid xl">
                                                  <div className="list-container">
                                                    {NullControl(merchantAgreementList)
                                                      ? merchantAgreementList.map(item => (
                                                        <div
                                                          key={item.guid}
                                                          className="form-check"
                                                        >
                                                          <RavenFormikField
                                                            errors={errors}
                                                            touched={touched}
                                                            name={item.guid}
                                                            label={getDescription(item)}
                                                            htmlLabel={true}
                                                            htmlLabelClick={e => {
                                                              this.clickHandler(e, item);
                                                            }}
                                                            setFieldValue={setFieldValue}
                                                            value={item.guid}
                                                            checked={this.state.agreementSelected.find(
                                                              obj =>
                                                                !!(
                                                                  obj.guid == item.guid &&
                                                                  obj != null
                                                                ),
                                                            )}
                                                            onChange={e => {
                                                              this.handleCheckBox(e, item);
                                                            }}
                                                            type="checkbox"
                                                          />
                                                        </div>
                                                      ))
                                                      : null}
                                                  </div>
                                                </div>
                                              </Col>
                                              <Col lg={12} className="col-12">
                                                <div className="mt-3 d-grid">
                                                  <br></br>
                                                  <button
                                                    className="btn btn-primary btn-block"
                                                    type="submit"
                                                  >
                                                    {this.props.t("approve")}
                                                  </button>
                                                </div>
                                              </Col>
                                            </Col>
                                          </Row>
                                        </Form>
                                      )}
                                    </Formik>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </Container>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment >
    );
  }
}



MerchantApplication.propTypes = {
  recordList: PropTypes.array,
  onGetRecordList: PropTypes.func,
  onGetUserCanMakeApplication: PropTypes.func,
  onGetUserCanApproveAgreement: PropTypes.func,
  onAddRecord: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  cmbMccList: PropTypes.array,
  onGetMccDefinition: PropTypes.func,
  cmbCityList: PropTypes.array,
  cmbCountryList: PropTypes.array,
  cmbDistrictList: PropTypes.array,
  cmbCountryStateList: PropTypes.array,
  cmbCompanyTypeList: PropTypes.array,
  cmbPaymentMethodList: PropTypes.array,
  cmbApplicationStatusList: PropTypes.array,
  cmbApplicationSubStatusList: PropTypes.array,
  onGetCountryDefinition: PropTypes.func,
  onGetCityDefinition: PropTypes.func,
  onGetDistrictDefinition: PropTypes.func,
  onGetCountryStateDefinition: PropTypes.func,
  onGetCompanyTypeDefinition: PropTypes.func,
  onGetPaymentMethodDefinition: PropTypes.func,
  onGetApplicationStatusDefinition: PropTypes.func,
  onGetApplicationSubStatusDefinition: PropTypes.func,
  onGetMerchantAgreementList: PropTypes.func,
  merchantAgreementList: PropTypes.array,
  onApproveMerchantAgreement: PropTypes.func,
  agreementsCreated: PropTypes.bool,
  applicationRecieved: PropTypes.bool,
  canApproveAgreement: PropTypes.bool,
  canMakeApplication: PropTypes.bool,
  onGetMerchantDocumentList: PropTypes.func,
  merchantDocumentList: PropTypes.array,
  onGetApplicationDocument: PropTypes.func,
  recordDocumentList: PropTypes.array,
  waitingFileBase64String: PropTypes.bool,
  fileViewData: PropTypes.any,
  onGetDocumentFileView: PropTypes.func,
};


const mapStateToProps = ({ merchantApplication, mccDefinition, countryDefinition, cityDefinition, countryStateDefinition, districtDefinition, companyTypeDefinition,
  paymentMethod, applicationSubStatus, applicationStatus, merchantAgreement }) => ({
    recordList: merchantApplication.recordList,
    cmbMccList: mccDefinition.recordList,
    cmbCityList: cityDefinition.recordList,
    cmbCountryList: countryDefinition.recordList,
    cmbCountryStateList: countryStateDefinition.countryStateList,
    cmbDistrictList: districtDefinition.recordList,
    cmbCompanyTypeList: companyTypeDefinition.recordList,
    cmbPaymentMethodList: paymentMethod.recordList,
    cmbApplicationStatusList: applicationStatus.recordList,
    cmbApplicationSubStatusList: applicationSubStatus.recordList,
    merchantAgreementList: merchantAgreement.merchantAgreementList,
    agreementsCreated: merchantApplication.agreementsCreated,
    applicationRecieved: merchantApplication.applicationRecieved,
    canApproveAgreement: merchantApplication.canApproveAgreement,
    canMakeApplication: merchantApplication.canMakeApplication,
    recordDocumentList: merchantApplication.recordDocumentList,
    waitingFileBase64String: merchantApplication.waitingFileBase64String,
    fileViewData: merchantApplication.fileViewData,
    error: merchantApplication.error
  });

const mapDispatchToProps = dispatch => ({
  onGetRecordList: record => dispatch(getUsersMerchantApplication(record)),
  onGetUserCanMakeApplication: record => dispatch(getUserCanMakeApplication(record)),
  onGetUserCanApproveAgreement: recordGetApprove => dispatch(getUserCanApproveAgreement(recordGetApprove)),
  onAddRecord: record => dispatch(addMerchantApplication(record)),
  onGetMccDefinition: () => dispatch(getMccList()),
  onGetCountryDefinition: () => dispatch(getCountryList()),
  onGetCityDefinition: () => dispatch(getCityDefinition()),
  onGetCountryStateDefinition: () => dispatch(getCountryStateDefinition()),
  onGetDistrictDefinition: () => dispatch(getDistrictDefinition()),
  onGetCompanyTypeDefinition: () => dispatch(getCompanyTypeDef()),
  apiError: error => dispatch(merchantApplicationApiError(error)),
  onGetPaymentMethodDefinition: () => dispatch(getPaymentMethodDef()),
  onGetApplicationStatusDefinition: () => dispatch(getApplicationStatusDef()),
  onGetApplicationSubStatusDefinition: () => dispatch(getApplicationSubStatusDef()),
  onGetMerchantAgreementList: () => dispatch(getMerchantAgreements()),
  onApproveMerchantAgreement: record => dispatch(approveMerchantAgreement(record)),
  onGetMerchantDocumentList: () => dispatch(getDocumentTypes()),
  onGetApplicationDocument: guid => dispatch(getApplicationDocumentByGuid(guid)),
  onGetDocumentFileView: subMerchantId => dispatch(getMerchantFileView(subMerchantId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(MerchantApplication));